import React from 'react'
import styled, { keyframes } from 'styled-components'
// import './styles.css'

const rotate = keyframes`  
  100% {
    transform: rotate(360deg);
  }
`;
const dash = keyframes`  
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

const LoadContainer = styled.div`
width: 100%;
height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 300
`
const Loader = styled.div`
  position: relative;
  margin: 0 auto;
  width: 100px;
  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`
const Circular = styled.svg`
  animation: ${rotate} 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`

const Path = styled.circle`
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: ${dash} 1.5s ease-in-out infinite;
  stroke-linecap: round;
  stroke: #FF6104;
`

export default (props) => {
  return (
    <LoadContainer style={props.stylesheet}>
      <Loader>
        <Circular viewBox="25 25 50 50">
          <Path cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
        </Circular>
      </Loader>
    </LoadContainer>
  );
}